import { ErrorGlobal } from '@xingternal/content-error';
import React from 'react';
import { useSelector } from 'react-redux';

import { RootState } from '../../../redux';
import { PreviewPage } from './PreviewPage';

export interface PreviewPageContainerProps {
  versionId: number;
  genericVersionId: number;
  locale: string;
}

export const PreviewPageContainer = ({
  versionId,
  genericVersionId,
  locale,
}: PreviewPageContainerProps): React.ReactElement => {
  const { loading, error, entity: previewPage } = useSelector<
    RootState,
    RootState['previewPage']
  >(state => state.previewPage);

  return (
    <div>
      {loading && <p>loading</p>}

      {error && <ErrorGlobal type="503" />}

      {!loading && !error && <PreviewPage pageDetails={previewPage} />}
    </div>
  );
};
